import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import DownloadIcon from "@mui/icons-material/Download";
import type { LogInfo } from "./useTaskDetailSubscription";
import type { ActionState } from "./useTaskDetailActions";
import { IfPermission } from "../../auth/IfPermission";

interface LogsSectionProps {
  logs: LogInfo[];
  onDownloadLog: () => void;
  downloadLogState: ActionState;
}

export function LogsSection(props: LogsSectionProps) {
  return (
    <Box mb={3}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="h6">Логи</Typography>
        <IfPermission permission="tasks.export">
          <Button
            size="small"
            startIcon={<DownloadIcon />}
            onClick={props.onDownloadLog}
            disabled={props.downloadLogState.kind === "loading"}
          >
            Скачать лог задачи
          </Button>
        </IfPermission>
      </Box>
      {props.logs.length > 0 && (
        <Paper variant="outlined" sx={{ maxHeight: 300, overflow: "auto", p: 1 }}>
          {[...props.logs].reverse().map((log) => {
            const isError = log.message.includes("failed");
            return (
              <Typography key={log.id} variant="body2" fontFamily="monospace" fontSize={12} py={0.25} color={isError ? "error" : undefined}>
                <Typography component="span" color={isError ? "error" : "text.secondary"} fontSize="inherit" fontFamily="inherit">
                  [{new Date(log.createdAt).toLocaleTimeString()}]
                </Typography>{" "}
                <Typography component="span" color={isError ? "error" : "text.secondary"} fontSize="inherit" fontFamily="inherit">
                  [{log.entityType}:{log.entityId}]
                </Typography>
                {log.publicationId !== null && (
                  <Typography component="span" color={isError ? "error" : "text.secondary"} fontSize="inherit" fontFamily="inherit">
                    {" "}(pub: {log.publicationId})
                  </Typography>
                )}
                {log.proxyId !== null && (
                  <Typography component="span" color={isError ? "error" : "text.secondary"} fontSize="inherit" fontFamily="inherit">
                    {" "}(proxy: {log.proxyId})
                  </Typography>
                )}
                {log.traceId !== null && (
                  <Link
                    component="button"
                    type="button"
                    underline="none"
                    color={isError ? "error" : "text.secondary"}
                    fontSize="inherit"
                    fontFamily="inherit"
                    sx={{ cursor: "pointer", textDecoration: "underline dotted" }}
                    title="Click to copy traceId"
                    onClick={() => {
                      if (log.traceId === null) {
                        return;
                      }
                      if (navigator.clipboard !== undefined) {
                        void navigator.clipboard.writeText(log.traceId);
                        return;
                      }
                      const textarea = document.createElement("textarea");
                      textarea.value = log.traceId;
                      textarea.style.position = "fixed";
                      textarea.style.left = "-9999px";
                      document.body.appendChild(textarea);
                      textarea.select();
                      document.execCommand("copy");
                      document.body.removeChild(textarea);
                    }}
                  >
                    {" "}[trace: {log.traceId}]
                  </Link>
                )}{" "}
                {log.message}
              </Typography>
            );
          })}
        </Paper>
      )}
    </Box>
  );
}
